import { render, staticRenderFns } from "./DetalleVehiculo.vue?vue&type=template&id=bcce51e8&scoped=true"
import script from "./DetalleVehiculo.vue?vue&type=script&lang=js"
export * from "./DetalleVehiculo.vue?vue&type=script&lang=js"
import style0 from "./DetalleVehiculo.vue?vue&type=style&index=0&id=bcce51e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcce51e8",
  null
  
)

export default component.exports